import { Link } from 'react-router-dom';
import type { Product } from '../lib/types';
import { TypeTheme, discountPercent, formatCount } from '../lib/types';
import { Badge, Price, grad } from './ui';

export function ProductCard({ product }: { product: Product }) {
  const t = TypeTheme[product.type];
  const off = discountPercent(product);
  return (
    <Link to={`/product/${product.id}`} className="pcard">
      <div className="pcard-thumb" style={grad(product.gradient)}>
        {product.emoji}
      </div>
      <div className="pcard-body">
        <Badge label={t.label} color={t.color} />
        <div className="pcard-title">{product.title}</div>
        <div className="row gap8" style={{ fontSize: 13 }}>
          <span className="stars">★ {product.rating.toFixed(1)}</span>
          <span className="faint">·</span>
          <span className="muted">{formatCount(product.students)}</span>
        </div>
        <div className="row gap12" style={{ marginTop: 4 }}>
          <Price price={product.price} mrp={product.mrp} />
          {off > 0 && <span className="off">{off}% off</span>}
        </div>
      </div>
    </Link>
  );
}

/** Full-width list row (used in Store / Category). */
export function ProductRow({ product }: { product: Product }) {
  const t = TypeTheme[product.type];
  const off = discountPercent(product);
  return (
    <Link to={`/product/${product.id}`} className="card row gap16" style={{ marginBottom: 14 }}>
      <div className="thumb" style={{ ...grad(product.gradient), width: 72, height: 72, fontSize: 30 }}>
        {product.emoji}
      </div>
      <div className="col" style={{ flex: 1, gap: 5 }}>
        <div className="row gap8 wrap">
          <Badge label={t.label} color={t.color} />
          {product.bestseller && <Badge label="Bestseller" color="#FF6B35" icon="🔥" />}
        </div>
        <div style={{ fontWeight: 700, fontSize: 15 }}>{product.title}</div>
        <div className="row gap8" style={{ fontSize: 13 }}>
          <span className="stars">★ {product.rating.toFixed(1)}</span>
          <span className="faint">·</span>
          <span className="muted">{formatCount(product.ratingCount)} reviews</span>
        </div>
        <div className="row gap12" style={{ marginTop: 2 }}>
          <Price price={product.price} mrp={product.mrp} />
          {off > 0 && <span className="off">{off}% off</span>}
        </div>
      </div>
      <span className="faint" style={{ fontSize: 22 }}>›</span>
    </Link>
  );
}
